import React from 'react'
// c:\xampp\htdocs\miners-market-main\pages\KpInsuranceAdminPage.js

function RequestDetailsModal({ request, onClose }) {
    if (!request) return null;

    const DetailItem = ({ label, value }) => {
        if (value === null || value === undefined || value === '') return null;
        const displayValue = typeof value === 'boolean' ? (value ? 'Yes' : 'No') : value;
        return (
            <div className="py-2">
                <p className="text-sm font-medium text-gray-500">{label}</p>
                <p className="text-gray-900">{String(displayValue)}</p>
            </div>
        );
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-xl p-8 max-w-2xl w-full max-h-[95vh] overflow-y-auto">
                <div className="flex justify-between items-center mb-6">
                    <h2 className="text-2xl font-bold text-gray-900">Insurance Request Details</h2>
                    <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
                        <i className="fas fa-times text-xl"></i>
                    </button>
                </div>
                <div className="space-y-4">
                    <div className="bg-gray-50 p-4 rounded-lg">
                        <h3 className="font-semibold text-lg mb-2">Insured / Company Details</h3>
                        <DetailItem label="Company Name" value={request.company_name} />
                        <DetailItem label="Trading As" value={request.trading_as} />
                        <DetailItem label="Contact Name" value={request.contact_name} />
                        <DetailItem label="Contact Numbers" value={request.contact_numbers} />
                        <DetailItem label="Email" value={request.email} />
                        <DetailItem label="Company Reg No" value={request.company_reg_no} />
                    </div>
                    <div className="bg-gray-50 p-4 rounded-lg">
                        <h3 className="font-semibold text-lg mb-2">Policyholder Type</h3>
                        <DetailItem label="Principal Contractor" value={request.principal_contractor} />
                        <DetailItem label="Sub-contractor" value={request.sub_contractor} />
                        <DetailItem label="Natural Person" value={request.natural_person} />
                        <DetailItem label="Legal Entity" value={request.legal_entity} />
                    </div>
                    <div className="bg-gray-50 p-4 rounded-lg">
                        <h3 className="font-semibold text-lg mb-2">Cover & Equipment Details</h3>
                        <DetailItem label="Owned Plant" value={request.owned_plant} />
                        <DetailItem label="Hired-in Plant" value={request.hired_in_plant} />
                        <DetailItem label="Owned Plant Hired-out" value={request.owned_plant_hired_out} />
                        <DetailItem label="Equipment Description" value={request.equipment_description} />
                        <DetailItem label="MM Number" value={request.mm_number} />
                        <DetailItem label="Equipment Year" value={request.equipment_year} />
                        <DetailItem label="Brief Note" value={request.brief_note} />
                    </div>
                    <div className="bg-gray-50 p-4 rounded-lg">
                        <h3 className="font-semibold text-lg mb-2">Contact & Consent</h3>
                        <DetailItem label="Preferred Contact: Call" value={request.contact_method_call} />
                        <DetailItem label="Preferred Contact: WhatsApp" value={request.contact_method_whatsapp} />
                        <DetailItem label="Preferred Contact: Email" value={request.contact_method_email} />
                        <DetailItem label="Consent to be contacted" value={request.consent} />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default function KpInsuranceAdminPage() {
    const [requests, setRequests] = React.useState([]);
    const [loading, setLoading] = React.useState(true);
    const [error, setError] = React.useState(null);
    const [selectedRequest, setSelectedRequest] = React.useState(null);

    React.useEffect(() => {
        const fetchRequests = async () => {
            setLoading(true);
            setError(null);
            try {
                const response = await fetch('/api/admin_get_kp_requests.php', { credentials: 'include' });
                if (!response.ok) {
                    const errData = await response.json();
                    throw new Error(errData.message || 'Failed to fetch requests.');
                }
                const data = await response.json();
                setRequests(data);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };
        fetchRequests();
    }, []);

    return (
        <>
            <div data-name="kp-insurance-admin-page" data-file="pages/KpInsuranceAdminPage.js" className="min-h-screen py-8">
                <div className="container mx-auto px-4">
                    <h1 className="text-4xl font-bold text-white mb-8">King Price Insurance Requests</h1>

                    <div className="bg-white rounded-xl shadow-lg p-6">
                        {loading && <div className="text-center py-10"><i className="fas fa-spinner fa-spin text-3xl text-blue-400"></i></div>}
                        {error && <div className="text-center py-10 text-red-500">Error: {error}</div>}
                        
                        {!loading && !error && requests.length === 0 && (
                            <div className="text-center py-10 text-gray-500">
                                <p className="text-lg">No insurance requests have been submitted yet.</p>
                            </div>
                        )}

                        {!loading && !error && requests.length > 0 && (
                            <div className="overflow-x-auto">
                                <table className="min-w-full divide-y divide-gray-200">
                                    <thead className="bg-gray-50">
                                        <tr>
                                            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Company Name</th>
                                            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Contact Name</th>
                                            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Contact Email</th>
                                            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Date Submitted</th>
                                            <th scope="col" className="relative px-6 py-3">
                                                <span className="sr-only">View</span>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody className="bg-white divide-y divide-gray-200">
                                        {requests.map(req => (
                                            <tr key={req.id}>
                                                <td className="px-6 py-4 whitespace-nowrap">
                                                    <div className="text-sm font-medium text-gray-900">{req.company_name}</div>
                                                </td>
                                                <td className="px-6 py-4 whitespace-nowrap">
                                                    <div className="text-sm text-gray-900">{req.contact_name}</div>
                                                </td>
                                                <td className="px-6 py-4 whitespace-nowrap">
                                                    <div className="text-sm text-gray-500">{req.email}</div>
                                                </td>
                                                <td className="px-6 py-4 whitespace-nowrap">
                                                    <div className="text-sm text-gray-500">{new Date(req.submission_date).toLocaleString()}</div>
                                                </td>
                                                <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                                                    <button onClick={() => setSelectedRequest(req)} className="text-blue-600 hover:text-blue-900">
                                                        View Details
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            {selectedRequest && <RequestDetailsModal request={selectedRequest} onClose={() => setSelectedRequest(null)} />}
        </>
    );
}
